import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Route as RouteIcon, User, Pencil, Trash2, ArrowRight } from "lucide-react";
import { formatDate } from "../../../utils/tspFormat";
import { leadSection, summarize } from "../adviceModel";
import AdviceCategoryBadge from "./AdviceCategoryBadge";

// One advice record: which sections it covers, an excerpt, and where it is from.
// `item.journey` / `item.team` / `item.submitted_by` are null when the advice
// belongs to another team's completed journey — shared as history, without
// saying whose it is.
export default function AdviceCard({ item, canManage, canOpenKnowledge, onDelete }) {
  const lead = leadSection(item);
  const cityLabel = item.location?.label || "Unknown city";
  const editable = canManage && item.journey?.status === "IN_PROGRESS";

  return (
    <article className="tsp-advice-card">
      <div className="tsp-advice-card-head">
        <span className="tsp-card-action-group">
          {item.categories.map((key) => (
            <AdviceCategoryBadge key={key} category={key} />
          ))}
        </span>
        <time className="tsp-muted-text" dateTime={item.created_at}>
          {formatDate(item.created_at.slice(0, 10))}
        </time>
      </div>

      <h3 className="tsp-advice-card-title">
        <Link to={`/tsp/advice/${item.id}`}>Advice for {cityLabel}</Link>
      </h3>
      {lead && (
        <p className="tsp-advice-card-summary">
          <strong>{lead.label}:</strong> {summarize(lead.text)}
        </p>
      )}

      <ul className="tsp-advice-card-meta">
        <li>
          <MapPin size={13} aria-hidden="true" />
          {canOpenKnowledge && item.location ? <Link to={`/tsp/knowledge/${item.location.id}`}>{cityLabel}</Link> : <span>{cityLabel}</span>}
        </li>
        <li>
          <RouteIcon size={13} aria-hidden="true" />
          {item.journey ? <Link to={`/tsp/journeys/${item.journey.id}`}>{item.journey.name}</Link> : <span>Another team&apos;s journey</span>}
        </li>
        {item.submitted_by && (
          <li>
            <User size={13} aria-hidden="true" />
            <span>
              {item.submitted_by.name}
              {item.team ? ` · ${item.team.name}` : ""}
            </span>
          </li>
        )}
      </ul>

      <div className="tsp-advice-card-actions">
        <Link to={`/tsp/advice/${item.id}`} className="tsp-btn tsp-btn-outline-info tsp-btn-sm">
          View Details <ArrowRight size={13} />
        </Link>
        {editable && (
          <span className="tsp-advice-card-manage">
            <Link to={`/tsp/advice/${item.id}/edit`} className="tsp-icon-link-btn" aria-label={`Edit advice for ${cityLabel}`}>
              <Pencil size={14} />
            </Link>
            <button type="button" className="tsp-icon-link-btn tsp-row-delete-btn" onClick={() => onDelete(item)} aria-label={`Delete advice for ${cityLabel}`}>
              <Trash2 size={14} />
            </button>
          </span>
        )}
      </div>
    </article>
  );
}
